import http from '../util/request.js'

export const getLiveList = (params) =>{
	return http({
		url:'/apistore/liveRoom/list',
		data:params,
		method:'get'
	})
}
export const getProductList = (params) =>{
	return http({
		url:'/apistore/liveRoom/productList',
		data:params,
		method:'get'
	})
}
export const getRobotList = (params) =>{
	return http({
		url:'/apistore/liveRoom/robotList',
		data:params,
		method:'get'
	})
}
export const applyRoom = (params) =>{
	return http({
		url:'/apistore/liveRoom/add',
		data:params,
		method:'post'
	})
}
export const getRoomDetail = (params) =>{
	return http({
		url:'/apistore/liveRoom/detail',
		data:params,
		method:'get'
	})
}
export const getRoomProductList = (params) =>{
	return http({
		url:'/apistore/liveRoom/productList',
		data:params,
		method:'get'
	})
}
export const editRoom = (params) =>{
	return http({
		url:'/apistore/liveRoom/edit',
		data:params,
		method:'post'
	})
}
export const editLiveOnline = (params) =>{
	return http({
		url:'/apistore/liveRoom/editLiveOnline',
		data:params,
		method:'post'
	})
}
export const delRoom = (params) =>{
	return http({
		url:'/apistore/liveRoom/del',
		data:params,
		method:'post'
	})
}